import { render } from "./Page6.vue?vue&type=template&id=265ba068&scoped=true"
import script from "./Page6.vue?vue&type=script&lang=js"
export * from "./Page6.vue?vue&type=script&lang=js"

import "./Page6.vue?vue&type=style&index=0&id=265ba068&scoped=true&lang=css"

import exportComponent from "/Users/felipewalflan/Documents/Gitlab gen-t/_front/base-questionnaire/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-265ba068"]])

export default __exports__